import { useTranslation } from "react-i18next";
import KeyValue from "../../common/KeyValue";

export function QueProps({question}){
    const {t}=useTranslation();
    const basicVals=[
        {key:t('Id'),value:question.id},
        {key:t('Category'),value:question.path},   
        {key:t('Type'),value:question.itemType},
        {key:t('Difficulty'),value:question.difficulty},
        {key:t('Weight'),value:question.weight}
    ]

    const timeVals=[
        {key:t('Created'),value:question.timeCreated},
        {key:t('Approved'),value:question.timeApproved},
        {key:t('Last_update'),value:question.timeModified},
        {key:t('Last_used'),value:question.timeUsed},
        {key:t('Usages'),value:question.usages}      
    ]
    const stateVals=[
        {key:t('Locked'),value:question.locked?t('TRUE'):t('FALSE')},
        {key:t('Approved'),value:question.approved?t('TRUE'):t('FALSE')},
        {key:t('Question_Author'),value:question.createdByName},
        {key:t('Approved_By'),value:question.approvedByName},
    ]

    return(
        <>
            <div className="grid m-0 mt-2 border-0 border-bottom-1 surface-border mb-2 surface-ground">  
                <div className="col"><KeyValue values={basicVals}></KeyValue></div> 
                <div className="col"><KeyValue values={timeVals}></KeyValue></div>
                <div className="col"><KeyValue values={stateVals}></KeyValue></div>
            </div>
        </>
    )
}